import SignInForm from "../components/sign_in_page/SignInForm";

export const SIGN_IN_PAGE_PATH = "/";

interface SignInPageProps {}

const SignInPage: React.FC<SignInPageProps> = (_) => {
  return <SignInForm />;
};

export default SignInPage;
